import React from 'react';
import PropTypes from 'prop-types';
import { Provider as ReduxProvider } from 'react-redux';
import IntlProvider from './IntlProvider';

function intlSelector(state) {
  const { intl } = state;

  return {
    ...intl,
    messages: intl.messages[intl.locale],
  };
}

const propTypes = {
  store: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired,
};

function Provider({ store: currentStore, children }) {
  return (
    <ReduxProvider store={currentStore}>
      <IntlProvider intlSelector={intlSelector}>
        {children}
      </IntlProvider>
    </ReduxProvider>
  );
}

Provider.propTypes = propTypes;

export default Provider;
